$(document).on("click", ".bulk_order_color", function () {
  var color_index = $(this).attr("data-target");
  color_index = color_index.replace("/", "\\/"); // Escape forward slash
  color_index = color_index.replace("-", "\\-"); // Escape hyphen
  $(this).toggleClass("selected");
  calculate_price();
  $("#size_table_wrap-" + color_index).toggleClass("is-hidden");
  if ($(".bulk_order_color.selected").length) {
    $("#size_table_wrap-demo").addClass("is-hidden");
  } else {
    $("#size_table_wrap-demo").removeClass("is-hidden");
  }
});

$(document).on( "change", ".product_bulk_form_atc input[type=number]", function () {
  var max = parseInt($(this).attr("max"));
  var min = parseInt($(this).attr("min"));
  var value = parseInt($(this).val());
  if(value > max){
     $(this).val(max);
  } 
  if(value < min){
    $(this).val(min);
  }
  calculate_price($(this));
});

$(document).on( "click", ".variant_column .quantity_wrap .icon.icon-plus, .variant_column .quantity_wrap .icon.icon-up", function (e) {
    e.preventDefault();
    var input_status = $(this).parent().find("input")[0].disabled;
    if (!input_status) {
      var qty = $(this).parent().find("input").val();
      var max = $(this).parent().find("input").attr("max");
      if (parseFloat(qty) == parseInt(qty) && !isNaN(qty)) {
        qty = parseInt(qty) + 1;
      } else {
        qty = 1;
      }
      if (qty > max) {
        qty = max;
      }
      $(this).parent().find("input").val(qty);
      $(this).parent().find("input").trigger("change");
    }else{
                $("#b2b_sticky_bar").addClass("animated bounceIn");
          $("#b2b_sticky_bar .warning_message").addClass("is-active");
          window.setTimeout(function () {
            $("#b2b_sticky_bar").removeClass("animated bounceIn");
            $("#b2b_sticky_bar .warning_message").removeClass("is-active");
          }, 3000);
    }
  });

$(document).on( "click", ".variant_column .quantity_wrap .icon.icon-minus,.variant_column .quantity_wrap .icon.icon-down", function (e) {
    e.preventDefault();
    var qty = $(this).parent().find("input").val();
    var min = $(this).parent().find("input").attr("min");
    if (parseFloat(qty) == parseInt(qty) && !isNaN(qty)) {
      qty = parseInt(qty) - 1;
    } else {
      qty = 1;
    }
    if (qty < min) {
      qty = min;
    }
    $(this).parent().find("input").val(qty);
    $(this).parent().find("input").trigger("change");
  });

$(document).on("click", ".bulk-clear-quantities", function (e) {
  e.preventDefault();
  resetSelection();
});

$(document).on("click", ".bulk-add-to-cart.btn--enable", function () {
     addMultipleItemsToCart();
  // var fileInput = document.getElementById("image_input");
  // // Get the selected file
  // var file = fileInput.files[0];
  // $(".bulk-add-to-cart.btn--enable").addClass("is-loading");
  // if (file) {
  //   // Create FormData object and append form data
  //   var formData = new FormData($("#product_image_upload")[0]);

  //   // Send AJAX request to add product to cart
  //   $.ajax({
  //     url: "/cart/add.js",
  //     type: "POST",
  //     data: formData,
  //     processData: false, // Prevent jQuery from automatically converting data to string
  //     contentType: false, // Set content type to false for FormData
  //     success: function (response) {
  //       var res = JSON.parse(response);
  //       var id = res.id;
  //       var img_link = res.properties.image;
  //       clearItem(id, img_link);
  //     },
  //     error: function (xhr, status, error) {
  //       console.error("Error adding product to cart:", error);
  //       $(".bulk-add-to-cart.btn--enable").removeClass("is-loading");
  //       // Handle error, e.g., display error message
  //     },
  //   });
  // } else {
  //   addMultipleItemsToCart();
  // }
});

$(document).ready(function () {
  var $scrollTrigger = $("#form_bottom");
  var $stickyElement = $("#product_bulk_sticky");

  // Function to toggle the sticky class based on scroll position
  if ($scrollTrigger.length > 0) {
    function toggleSticky() {
      if ($(window).scrollTop() >= $scrollTrigger.offset().top) {
        $stickyElement.addClass("sticky");
      } else {
        $stickyElement.removeClass("sticky");
      }
    }
  }

  // Add scroll event listener to window
  $(window).scroll(toggleSticky);

  var dropZone = $("#product_image_upload");

  // Add event listeners for drag and drop
  dropZone.on("dragover", function (e) {
    e.preventDefault();
    e.stopPropagation();
    $(this).addClass("dragover");
  });

  dropZone.on("dragleave", function (e) {
    e.preventDefault();
    e.stopPropagation();
    $(this).removeClass("dragover");
  });

  dropZone.on("drop", function (e) {
    e.preventDefault();
    e.stopPropagation();
    $(this).removeClass("dragover");

    var files = e.originalEvent.dataTransfer.files;
    handleFiles(files);
    //   $('#image_input').click();
  });
});

$("#image_input").on("change", function () {
  previewImage(this);
});

function resetSelection() {
  $(".bulk_order_color.selected").removeClass("selected");
  $(".variant_column_wrap input").val("");
  $(".color_table").addClass("is-hidden");
  $("#size_table_wrap-demo").removeClass("is-hidden");
  calculate_price();
}

// function clearItem(key, image) {
//   $.ajax({
//     type: "POST",
//     url: "/cart/change.js",
//     dataType: "json",
//     data: {
//       id: key,
//       quantity: 0, // Set quantity to 0 to remove the item
//     },
//     success: function (response) {
//       addMultipleItemsToCart(image);
//     },
//     error: function (xhr, status, error) {
//       console.error("Error removing item from cart:", error);
//       $(".bulk-add-to-cart.btn--enable").removeClass("is-loading");
//     },
//   });
// }

function addMultipleItemsToCart(image = null) {
  var itemsToAdd = [];
  // // Get the file input element
  // var fileInput = document.getElementById("image_input");
  // // Get the selected file
  // var file = fileInput.files[0];
  $(".bulk_order_color.selected").each(function () {
    var selected_element = $(this);
    var color_index = selected_element.attr("data-target");
    color_index = color_index.replace("/", "\\/"); // Escape forward slash
    color_index = color_index.replace("-", "\\-"); // Escape hyphen
    // $("#size_table_wrap-" + color_index).toggleClass("is-hidden");
    var number_el = $("#size_table_wrap-" + color_index).find("input[type=number]");
    number_el.each(function () {
      var qty = $(this).val();
      if (qty && qty > 0) {
        var price = $(this).attr("data-price");
        var id = $(this).attr("data-vid");
        var item = {
          id: id, // Variant ID of the item
          quantity: qty, // Quantity of the item to add
        };
        // if (image !== null) {
        //   // Add image data to item properties
        //   item.properties = {
        //     image: image,
        //   };
        // }
        itemsToAdd.push(item);
      }
    });
  });

  if (itemsToAdd.length > 0) {
    // Prepare the data to be sent
    var data = {
      items: itemsToAdd,
    };

    // Make AJAX request to add items to cart
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function () {
        $(".bulk-add-to-cart.btn--enable").removeClass("is-loading");
        Shopify.theme.jsAjaxCart.showDrawer();
        Shopify.theme.jsAjaxCart.updateView();

        $(".bulk_order_color.selected").each(function () {
          var selected_element = $(this);
          var color_index = selected_element.attr("data-target");
          color_index = color_index.replace("/", "\\/"); // Escape forward slash
          color_index = color_index.replace("-", "\\-"); // Escape hyphen
          // $("#size_table_wrap-" + color_index).toggleClass("is-hidden");
          var number_el = $("#size_table_wrap-" + color_index).find(
            "input[type=number]"
          );
          number_el.each(function () {
            var qty = $(this).val();
            var max = $(this).attr("max");
            if (qty && qty > 0) {
              var new_Stock = max - qty;
              var max = $(this).attr("max", new_Stock);
              if (new_Stock <= 0) {
                $(this).attr("disabled", true);
                $(this)
                  .parents(".variant_column_wrap")
                  .find(".inventory_available ")
                  .html("<span class='text-orange'> Not Available </span>");
              } else {
                $(this)
                  .parents(".variant_column_wrap")
                  .find(".inventory_available ")
                  .text(new_Stock + " Left ");
              }
            }
          });
        });

        resetSelection();
      },
      error: function (xhr, status, error) {
        console.error("Error adding items to cart:", error);
        $(".bulk-add-to-cart.btn--enable").removeClass("is-loading");
        // Optionally, display an error message to the user
      },
    });
  }
}

function handleFiles(files) {
  // Check if files were dropped
  if (files.length > 0) {
    var file = files[0];
    let fileType = file.type;
    let validExtensions = ["image/jpeg", "image/jpg", "image/png"];
    var reader = new FileReader();
    if (validExtensions.includes(fileType)) {
      // Read the file as a data URL
      reader.readAsDataURL(file);

      // Set up the onload event handler
      reader.onload = function () {
        var imgSrc = reader.result;
        $("#image_input").prop("files", files);
        $("#preview_image").attr("src", imgSrc);
        $("#preview_image").parent().addClass("uploaded");
        $("#image_input").trigger("change");
      };
    } else {
      alert("This is not an Image File");
      dropArea.classList.remove("active");
    }
  }
}

function previewImage(input) {
  if (input.files && input.files[0]) {
    var reader = new FileReader();

    reader.onload = function (e) {
      $("#preview_image").attr("src", e.target.result);
      $("#preview_image").parent().addClass("uploaded");
    };

    reader.readAsDataURL(input.files[0]);
  }
}

function calculate_price($ele) {
  // console.log("calculate trigger");
  var total_price = 0.0;
  var total_qty = 0;
  var threshold = $("#customer_order_limit").val();
  $(".bulk_order_color.selected").each(function () {
    var selected_element = $(this);
    var color_index = selected_element.attr("data-target");
    color_index = color_index.replace("/", "\\/"); // Escape forward slash
    color_index = color_index.replace("-", "\\-"); // Escape hyphen
    // $("#size_table_wrap-" + color_index).toggleClass("is-hidden");
    var number_el = $("#size_table_wrap-" + color_index).find(
      "input[type=number]"
    );
    number_el.each(function () {
      var qty = $(this).val();
      if (qty && qty > 0) {
        var price = $(this).attr("data-price");
        var total = price * qty;
        total_price += total;
        total_qty += parseInt(qty);
      }
    });
  });
  if (total_qty > 0) { $(".bulk-add-to-cart").addClass("btn--enable");}
  else { $(".bulk-add-to-cart").removeClass("btn--enable");}
  
  $("#form_bottom .bulk_total_qty").text(total_qty + (total_qty > 1 ? " Units" : " Unit"));
  $("#product_bulk_sticky .bottom_total_qty").text(total_qty + (total_qty > 1 ? " Units" : " Unit"));
  $(".bulk_total").text(Shopify.formatMoney(total_price, $("body").data("money-format")));
  $(".bottom_total_amt").text(Shopify.formatMoney(total_price, $("body").data("money-format")));

  if ($("#customer_order_limit").length > 0) {
    if ($ele) {
      var _value = $ele.val();
      var _unit_price = $ele.attr("data-price")/100;
    }
    // $("#b2b_sticky_bar").addClass("is-sticky");
    
    fetch(window.Shopify.routes.root + "cart.js")
      .then((response) => response.json())
      .then((data) => {
        var item_total = (total_price + data.total_price) / 100;
       
        if (item_total > threshold) {
          if ($ele) {
            var reset_amount = item_total - (_value * _unit_price);
            var available_amount = threshold - reset_amount;
            var new_qty = Math.floor(available_amount / _unit_price);            
            $ele.val(new_qty);
            $ele.trigger("change");
          }
          $("#b2b_sticky_bar").addClass("animated bounceIn");
          $("#b2b_sticky_bar .warning_message").addClass("is-active");
          window.setTimeout(function () {
            $("#b2b_sticky_bar").removeClass("animated bounceIn");
            $("#b2b_sticky_bar .warning_message").removeClass("is-active");
          }, 3000);
        } 
        else {
          var rem = (threshold - item_total) * 100;
          var rem_formatted = threshold - item_total;
          var remaining_price = Shopify.formatMoney(rem, $('body').data('money-format'));
           $(".sticky-bar__text .general_message").addClass("is-hidden");
          $(".sticky-bar__text .text_message").removeClass("is-hidden");
          $(".sticky-bar__text #info_message").text(remaining_price);
          $(".product_bulk_form_atc input[type=number]").each(function () {
            var price = $(this).attr("data-price") / 100;
            if (rem_formatted > price) {
              $(this).attr("disabled", false);
            } else {
              $(this).attr("disabled", true);
            }
          });
        }


        return false;
      });
    }
}